module.exports = __webpack_public_path__ + "img/buildingscontents.0329dfb1.svg";